"use client";

import Image, { type ImageProps } from "next/image";
import { useState } from "react";

interface SafeImageProps extends Omit<ImageProps, "onError"> {
  placeholderText?: string;
}

export function SafeImage({ placeholderText = "No Image", alt, className, ...props }: SafeImageProps) {
  const [error, setError] = useState(false);

  if (error) {
    return (
      <div className={`flex flex-col items-center justify-center bg-gray-100 dark:bg-gray-800 text-muted ${className || ""}`}>
        <svg className="w-10 h-10 mb-1 opacity-30" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M2 12l1.5-4.5L7 9l5-7 4 5 3-2 3 6v6a2 2 0 01-2 2H4a2 2 0 01-2-2v-3z" />
        </svg>
        <span className="text-xs opacity-50">{placeholderText}</span>
      </div>
    );
  }

  return (
    <Image
      {...props}
      alt={alt}
      className={className}
      onError={() => setError(true)}
    />
  );
}
